import { ReactNode } from "react";

type Props = {
  dataMzAccent: string;
  children: ReactNode;
};

export default function FactionWrapper({ dataMzAccent, children }: Props) {
  return (
    <div className="relative flex flex-col size-full bg-dark-900" data-mz-accent={dataMzAccent}>
      {children}
    </div>
  );
}
